module.exports = __webpack_public_path__ + "4f09ff303f319873bccea6ecfbbbea2e.svg";